import {
  ROLES,
  RoleType,
  normalizeRoleName,
} from "../../Utils/Constants/RoleConstants";

/**
 * Authored Guidance Hub roles — one content matrix row per login role.
 * vendor_admin / izba_admin have no authored hub; they can still browse
 * /guidance/playbooks and switch between these roles.
 */
export type GuidanceRole =
  | "ae"
  | "csm"
  | "se"
  | "tam"
  | "bcs"
  | "sdr"
  | "vp"
  | "executive_sponsor"
  | "executive"
  | "executive_sponsor_lead"
  | "c_level";

export const GUIDANCE_ROLES: {
  key: GuidanceRole;
  label: string;
  shortLabel: string;
}[] = [
  { key: "ae", label: "AE", shortLabel: "AE" },
  { key: "csm", label: "CSM", shortLabel: "CSM" },
  { key: "se", label: "SE", shortLabel: "SE" },
  { key: "tam", label: "TAM", shortLabel: "TAM" },
  { key: "bcs", label: "BCS", shortLabel: "BCS" },
  { key: "sdr", label: "SDR", shortLabel: "SDR" },
  { key: "vp", label: "VP", shortLabel: "VP" },
  {
    key: "executive_sponsor",
    label: "Executive Sponsor",
    shortLabel: "Sponsor",
  },
  { key: "executive", label: "Executive", shortLabel: "Exec" },
  {
    key: "executive_sponsor_lead",
    label: "Executive Sponsor Lead",
    shortLabel: "ESL",
  },
  { key: "c_level", label: "C-Level", shortLabel: "CXO" },
];

export const GUIDANCE_ROLE_KEYS = GUIDANCE_ROLES.map(r => r.key);

const AUTHORED_ROLE_SET = new Set<string>(GUIDANCE_ROLE_KEYS);

/** Roles that author content (have their own default hub). */
export const hasOwnGuidanceHub = (
  userRole: string | { name?: string } | null | undefined
): boolean => {
  const normalized = normalizeRoleName(userRole);
  return Boolean(normalized && AUTHORED_ROLE_SET.has(normalized));
};

/**
 * Default role tab for the Hub. Authored roles default to themselves.
 * Browse-only roles (vendor_admin, izba_admin) fall back to AE.
 */
export const getDefaultGuidanceRole = (
  userRole: string | { name?: string } | null | undefined
): GuidanceRole => {
  const normalized = normalizeRoleName(userRole);
  if (normalized && AUTHORED_ROLE_SET.has(normalized)) {
    return normalized as GuidanceRole;
  }
  return "ae";
};

export const isCLevelGuidanceRole = (role: string): boolean =>
  role === ROLES.C_LEVEL || role === "c_level";

export type { RoleType };
